import { useEffect } from "react";

import {
  aliasProductUser,
  getCurrentProductDistinctId,
  getCurrentProductUserId,
  identifyProductOrganization,
  identifyProductUser,
  isProductAnalyticsEnabled,
  resetProductAnalytics,
} from "@/lib/product-analytics";
import type { Auth } from "@/serializers";

type PosthogUserSyncProps = {
  auth: Auth;
};

export function PosthogUserSync({ auth }: PosthogUserSyncProps) {
  useEffect(() => {
    if (!isProductAnalyticsEnabled()) return;

    const user = auth.user;
    if (!user) {
      if (getCurrentProductUserId()) {
        resetProductAnalytics();
      }

      return;
    }

    const distinctId = String(user.id);
    const currentDistinctId = getCurrentProductDistinctId();
    const currentUserId = getCurrentProductUserId();

    if (!currentUserId && currentDistinctId && currentDistinctId !== distinctId) {
      aliasProductUser(distinctId, currentDistinctId);
    }

    identifyProductUser({
      distinctId,
      email: user.email,
      name: user.name,
      organizationId: user.organizationId,
      organizationName: user.organizationName,
      role: user.role,
      verified: user.verified,
    });

    if (user.organizationId && user.organizationName) {
      identifyProductOrganization({
        id: String(user.organizationId),
        name: user.organizationName,
      });
    }
  }, [auth.user]);

  return null;
}
